import {
	ButtonComponent,
	CarSearch,
	CheckboxComponent,
	CheckboxConsentComponent,
	CtaGroupComponent,
	DatePickerComponent,
	DetailsListComponent,
	DividerComponent,
	GetFeedbackComponent,
	HeadlineComponent,
	IframeComponent,
	InputTextFieldComponent,
	ListComponent,
	ModalContentComponent,
	PackageComponent,
	ParagraphComponent,
	RadioCardComponent,
	RadioSliderComponent,
	ScrollableRadioListComponent,
	SearchFieldComponent,
	SelectFieldComponent,
	SummaryComponent,
	SummaryTotalPriceComponent,
	SystemIconsComponent,
	TeaserCardComponent,
} from 'components';
import { memo } from 'react';

export const Component: React.FC<any> = memo((props) => {
	const components = {
		CheckboxFieldBlock: CheckboxComponent,
		DatePickerFieldBlock: DatePickerComponent,
		InlineFrameBlock: IframeComponent,
		InputTextfieldBlock: InputTextFieldComponent,
		ModalContentBlock: ModalContentComponent,
		FlowRestrictionBlock: ModalContentComponent,
		RadioCardFieldBlock: RadioCardComponent,
		RadioSliderBlock: RadioSliderComponent,
		SearchFieldBlock: SearchFieldComponent,
		SelectFieldBlock: SelectFieldComponent,
		ScrollableRadioListFieldBlock: ScrollableRadioListComponent,
		ButtonBlock: ButtonComponent,
		UserConsentBlock: CheckboxConsentComponent,
		TeaserCardBlock: TeaserCardComponent,
		CtaGroupBlock: CtaGroupComponent,
		SummaryProductDetailsBlock: SummaryComponent,
		SummaryTotalPriceDetailsBlock: SummaryTotalPriceComponent,
		DetailsListBlock: DetailsListComponent,
		SystemIconsBlock: SystemIconsComponent,
		HeadLineBlock: HeadlineComponent,
		ParagraphBlock: ParagraphComponent,
		ListBlock: ListComponent,
		DividerBlock: DividerComponent,
		PackageGroupBlock: PackageComponent,
		CarSearchBlock: CarSearch,
		GetFeedback: GetFeedbackComponent,
	};

	const DynamicComponent = components[props.contentType as keyof typeof components];

	if (typeof DynamicComponent === 'undefined') {
		// TODO: Should it break in build?s
		console.error(`Component [${props.contentType}] is missing a React Component. Check /components/Component.tsx`);
		return (
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					height: '100px',
					width: '100%',
					border: '10px red solid',
					fontSize: 'larger',
					fontWeight: 'bold',
					boxSizing: 'border-box',
				}}
			>{`Component [${props.contentType}] is missing a React Component. Check /components/Component.tsx`}</div>
		);
	}
	return <DynamicComponent {...props} />;
});

Component.displayName = 'Component';
